import { render, staticRenderFns } from "./MenuMore.vue?vue&type=template&id=17853d98&scoped=true"
import script from "./MenuMore.vue?vue&type=script&lang=js"
export * from "./MenuMore.vue?vue&type=script&lang=js"
import style0 from "./MenuMore.vue?vue&type=style&index=0&id=17853d98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17853d98",
  null
  
)

export default component.exports